import React from 'react';
import { MapPinIcon, ExternalLinkIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { GOOGLE_MAPS_URL, PROPERTY_ADDRESS } from '../data/contact';
import { trackEvent } from '../utils/analytics';
import { Reveal } from './Reveal';
import { PalmLines } from './PalmLines';
const HIGHLIGHTS = [{
  en: 'Near Disney',
  es: 'Cerca de Disney'
}, {
  en: 'Central Florida attractions',
  es: 'Atracciones de Florida Central'
}, {
  en: 'Shopping and dining nearby',
  es: 'Compras y restaurantes cercanos'
}, {
  en: 'Golf and entertainment',
  es: 'Golf y entretenimiento'
}, {
  en: 'Convenient road access',
  es: 'Acceso conveniente a vías principales'
}, {
  en: 'Resort-style community',
  es: 'Comunidad estilo resort'
}];
export function LocationSection() {
  const {
    lang,
    t
  } = useLanguage();
  return <section id="location" className="w-full bg-white py-20 lg:py-28" data-id="element-377" data-mp="6rckws5znuag">
      <div className="mx-auto max-w-editorial px-5 lg:px-8" data-id="element-378" data-mp="2qam2cfzhk90">
        <div className="grid gap-12 lg:grid-cols-12 lg:gap-16" data-id="element-379" data-mp="2mqlu8zpq6g0h">
          <div className="lg:col-span-5" data-id="element-380" data-mp="2ms6lafctzgtl">
            <Reveal data-id="element-381" data-mp="2rpf7qs50i70n">
              <p className="label-caps text-gold" data-id="element-382" data-mp="2rox59drrawka">
                {t('Central Florida Lifestyle', 'El Estilo de Vida de Florida Central')}
              </p>
              <h2 className="mt-5 max-w-[16ch] font-display text-[32px] font-semibold uppercase leading-[1.03] text-midnight sm:text-[42px] lg:text-[48px]" data-id="element-383" data-mp="2wmyj9kabs5ow">
                {t('Davenport Living, Close to the Magic', 'Vive en Davenport, Cerca de la Magia')}
              </h2>
              <div className="gold-rule mt-6 w-24" data-id="element-384" data-mp="3aed5dzzj4n06" />
              <p className="mt-6 text-[15px] leading-relaxed text-ink/80 lg:text-base" data-id="element-385" data-mp="3fergxs0caf2y">
                {t('Located in Davenport, Florida, the property offers convenient access to Central Florida attractions, shopping, restaurants, golf and major roadways.', 'Ubicada en Davenport, Florida, la propiedad ofrece acceso conveniente a las atracciones de Florida Central, centros comerciales, restaurantes, campos de golf y vías principales.')}
              </p>
              <ul className="mt-8 grid gap-x-8 gap-y-3 sm:grid-cols-2 lg:grid-cols-1" data-id="element-386" data-mp="1dz3fk7vdjkvr">
                {HIGHLIGHTS.map(item => <li key={item.en} className="flex items-center gap-3 text-[14px] text-ink/85" data-id="element-387" data-mp="1rz4gfnbn2sb8">
                    <span aria-hidden="true" className="h-1.5 w-1.5 shrink-0 bg-gold" data-id="element-388" data-mp="1mxf3g24uw4ki" />
                    {lang === 'en' ? item.en : item.es}
                  </li>)}
              </ul>
            </Reveal>
          </div>

          <Reveal className="lg:col-span-7" delay={0.06} data-id="element-389" data-mp="2ao195mre1crc">
            <div className="relative flex h-[320px] w-full flex-col items-center justify-center overflow-hidden bg-midnight px-6 text-center sm:h-[420px] lg:h-[520px]" data-id="element-390" data-mp="2anj3y0mqzo7a">
              <PalmLines className="pointer-events-none absolute -left-6 bottom-0 h-56 w-40 opacity-30" data-id="element-391" data-mp="2knjqrwjtsmg8" />
              <PalmLines className="pointer-events-none absolute -right-6 top-0 h-56 w-40 opacity-20" flip data-id="element-392" data-mp="2fooz053vrnjz" />
              <MapPinIcon className="h-8 w-8 text-gold" aria-hidden="true" data-id="element-393" data-mp="2z9p7ygkim982" />
              <p className="label-caps mt-5 text-white/60" data-id="element-394" data-mp="339rast1zl8ox">
                {t('Property Location', 'Ubicación de la Propiedad')}
              </p>
              <p className="mt-3 max-w-[22ch] font-display text-[24px] font-medium uppercase leading-tight text-white sm:text-[30px]" data-id="element-395" data-mp="2pd44w0s2386v">
                {PROPERTY_ADDRESS}
              </p>
              <div className="gold-rule mt-6 w-16" data-id="element-396" data-mp="2fjww05y3xa21" />
              <a href={GOOGLE_MAPS_URL} target="_blank" rel="noopener noreferrer" onClick={() => trackEvent('map_open', {
              destination: 'google_maps'
            })} className="mt-7 inline-flex items-center gap-2 bg-gold px-6 py-3.5 font-display text-[12px] font-medium uppercase tracking-[0.16em] text-midnight transition-colors duration-150 ease-out hover:bg-gold-soft" data-id="element-397" data-mp="2kc6jzgfnw01o">
                {t('Open in Google Maps', 'Abrir en Google Maps')}
                <ExternalLinkIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-398" data-mp="34v1em48u2ln6" />
              </a>
            </div>
          </Reveal>
        </div>
      </div>
    </section>;
}